<template>
  <div class="migrants_wrap">
    <ioc-table
      ref="refPeoPleTable"
      :data="migrantsTableData"
      :option="constData.migrantsTable"
      :page="constData.migrantsPage"
      @search-change="
        (val) => {
          handleSearchChange(val, 'migrants');
        }
      "
      @search-reset="
        (val) => {
          handleSearchReset('migrants');
        }
      "
      @size-change="
        (val) => {
          handleSizeChange(val, 'migrants');
        }
      "
      @current-change="
        (val) => {
          handleCurrentChange(val, 'migrants');
        }
      "
    >
    </ioc-table>
  </div>
</template>

<script>
import { api } from "../api/index";
import utils from "@src/common/utils";
import { migrantsTable } from "../config/migrants";
export default {
  data() {
    return {
      migrantsTableData: [],
      constData: {
        migrantsPage: {
          pageNum: 1,
          total: 0,
          pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10,
        },
        migrantsTable: migrantsTable(),
        migrantsSearchForm: {},
      },
    };
  },
  created() {},
  mounted() {
    this.migrantsGetList();
  },
  methods: {
    migrantsGetList() {
      let params = {
        ...this.constData.migrantsPage,
        ...this.constData.migrantsSearchForm,
        personnelType: 2,
      };
      this.$fetch(api.getAuthorityList, params).then((res) => {
        if (!res.success) {
          this.$$message.error(res.msgContent || "获取数据失败");
          return;
        }
        this.migrantsTableData = res.returnObj.list.map((el) => {
          return el;
        });
        this.constData.migrantsPage.total = res.returnObj.total;
      });
    },
    // 条件搜索
    handleSearchChange(param, type) {
      this.constData[`${type}Page`].pageNum = 1;
      this.constData[`${type}SearchForm`] = Object.assign({}, param);
      this[`${type}GetList`]();
    },
    // 条件重置
    handleSearchReset(type) {
      this.constData[`${type}Page`].pageNum = 1;
      this.constData[`${type}Page`].pageSize = 10;
      this.constData[`${type}SearchForm`] = {};
      this[`${type}GetList`]();
    },
    // 分页查询
    handleCurrentChange(val, type) {
      this.constData[`${type}Page`].pageNum = val;
      this[`${type}GetList`]();
    },
    // 条数查询
    handleSizeChange(val, type) {
      this.constData[`${type}Page`].pageNum = 1;
      this.constData[`${type}Page`].pageSize = val;
      this[`${type}GetList`]();
    },
  },
};
</script>

<style lang="scss" scoped>
.migrants {
  &_wrap {
    width: 100%;
    height: 100%;
  }
}
</style>